{% block sw_cms_sidebar_section_settings %}
    {% parent %}

    {% block swag_cms_extensions_sidebar_block_behavior_settings_content %}
        <template v-if="selectedBlock">
            <swag-cms-extensions-block-config-rule v-model:block="selectedBlock" />

            <swag-cms-extensions-block-config-quickview v-model:block="selectedBlock" />
        </template>
    {% endblock %}
{% endblock %}

{% block sw_cms_sidebar_section_settings_content %}
    {% parent %}

    {% block swag_cms_extensions_sidebar_section_settings_scroll_navigation %}
        <sw-sidebar-collapse :expandOnLoading="true">
            {% block swag_cms_extensions_sidebar_section_settings_scroll_navigation_header %}
                <template #header>
                    {{ $tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.title') }}
                </template>
            {% endblock %}

            {% block swag_cms_extensions_sidebar_section_settings_scroll_navigation_content %}
                <template #content>
                    <swag-cms-extensions-section-scroll-behavior-config v-model:section="selectedSection" />
                </template>
            {% endblock %}
        </sw-sidebar-collapse>
    {% endblock %}
{% endblock %}

{% block sw_cms_sidebar_navigator_section_header %}
    <div :class="navigatorSectionHeaderWrapperClass(section)">
        {% parent %}
    </div>
{% endblock %}

{% block sw_cms_sidebar_navigator_section_menu %}
    {% block sw_cms_sidebar_navigator_section_menu_scroll_navigation_anchor %}
        <div v-if="scrollNavigationIsActive(section)">
            <mt-icon
                v-tooltip="scrollNavigationAnchorTooltip(section)"
                class="navigator-section-header__scroll-navigation-anchor"
                name="regular-tag"
                size="16"
            />
        </div>
    {% endblock %}

    {% parent %}
{% endblock %}

{% block sw_cms_sidebar_page_settings_content %}
    {% parent %}

    {% block sw_cms_sidebar_page_settings_content_scroll_navigation %}
        <sw-sidebar-collapse :expandOnLoading="true">
            {% block sw_cms_sidebar_page_settings_content_scroll_navigation_header %}
                <template #header>
                    {{ $tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.title') }}
                </template>
            {% endblock %}

            {% block sw_cms_sidebar_page_settings_content_scroll_navigation_header_content %}
                <template #content>
                    <swag-cms-extensions-page-scroll-behavior-config v-model:page="page" />
                </template>
            {% endblock %}
        </sw-sidebar-collapse>
    {% endblock %}
{% endblock %}
